import { api } from './api';

export interface FirmMember {
  id: number;
  name: string;
}

export interface Firm {
  id: number;
  name: string;
  created_by: number | null;
  created_at: string;
  members: FirmMember[];
  member_ids: number[];
}

export interface FirmInput {
  name?: string;
  member_ids?: number[];
}

export const firmsApi = {
  list: () => api.get<Firm[]>('/firms'),

  create: (data: FirmInput) => api.post<Firm>('/firms', data),

  update: (id: number, data: FirmInput) => api.patch<Firm>(`/firms/${id}`, data),

  remove: (id: number) => api.delete<{ ok: boolean }>(`/firms/${id}`),

  // Firm-scoped picker: accounts sharing a firm with the caller (admins get all active).
  colleagues: () => api.get<FirmMember[]>('/firms/colleagues'),
};
